import React from 'react';
import { Box, IconButton, Option, Select, Typography } from '@mui/joy';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { PAGE_TRANSLATIONS } from '../conf';

interface CustomPaginationProps {
  count: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (newPage: number) => void;
  onRowsPerPageChange: (newRowsPerPage: number) => void;
}

const CustomPagination: React.FC<CustomPaginationProps> = ({ count, page, rowsPerPage, onPageChange, onRowsPerPageChange }) => {
  const totalPages = Math.ceil(count / rowsPerPage);

  const handlePreviousPage = () => {
    if (page > 1) {
      onPageChange(page - 1);
    }
  };

  const handleNextPage = () => {
    if (page < totalPages) {
      onPageChange(page + 1);
    }
  };

  const handleRowsPerPageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    onRowsPerPageChange(parseInt(event.target.value, 10));
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 1 }}>
      <IconButton size="sm" color="neutral" variant="outlined" onClick={handlePreviousPage} disabled={page === 1}>
        <ChevronLeft />
      </IconButton>
      <Typography>{`${PAGE_TRANSLATIONS.PAGE} ${page} / ${totalPages}`}</Typography>
      <IconButton size="sm" color="neutral" variant="outlined" onClick={handleNextPage} disabled={page === totalPages}>
        <ChevronRight />
      </IconButton>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Select
          size="sm"
          value={rowsPerPage}
          onChange={(_e, newValue) => handleRowsPerPageChange({ target: { value: newValue } } as any)}
          sx={{ minWidth: 80 }}
        >          
          <Option value={10}>10</Option>          
          <Option value={50}>50</Option>
          <Option value={100}>100</Option>
          <Option value={500}>500</Option>
          <Option value={1000}>1000</Option>
        </Select>
      </Box>
    </Box>
  );
};

export default CustomPagination; 